/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：428__part-12
 */

"use strict"

var rc
import * as /* [auto-meaningful-name] */Module_429 from /* 429 */"../429"
!function (e) {
  e.STACK_EXCEEDED = "STACK_EXCEEDED"
}(rc || (rc = {}))
export { rc }
